const Cliente = {
    id: 0,
    estampariaId: 0,
    nome: ""
}

export default Cliente;